<div class="clr-row!">
  <div class="clr-col-12" style="margin-bottom: 32px">
    <h1>Hallo!</h1>
    <p>Willkommen beim powerslide Tool der cronos.</p>
  </div>
  <div class="clr-col-md-6 clr-col-12">
    <div class="card">
      <a
        href="https://cronosnet.sharepoint.com/:v:/t/C_181/IQDV4WoKXME-RaFBZoC55MTRAYff76tgP5Gv4Q4G3x0hojw?e=l1Polu"
        target="_blank"
      >
        <div class="card-img">
          <img
            src="assets/img/powerslide_3.png"
            style="max-width: 100%; height: auto"
            alt="Screenshot von einem Erklärvideo. Rechts steht Robert. Links ist sein Bildschirminhalt zu sehen."
          />
        </div>
      </a>
      <div class="card-block">
        <p class="card-text">
          Robert gibt euch eine kurze Einleitung in die Benutzung von Powerslide
        </p>
      </div>
    </div>
  </div>
</div>
